import React from 'react';

import styles from './MessagesList.module.scss';

export const MessagesList: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const chatBottomAnchorRef = React.useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    chatBottomAnchorRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'end',
    });
  };

  React.useEffect(() => {
    setTimeout(() => {
      scrollToBottom();
    }, 0);

    setTimeout(() => {
      scrollToBottom();
    }, 500);
  }, [children]);

  return (
    <div className={styles['messages-list']}>
      {children}
      <div ref={chatBottomAnchorRef} />
    </div>
  );
};
